export const OLD_ADMIN_HOSTNAME = {
    localhost: 'localhost',
    sit: 'adm.sit.test.visma.net',
    int: 'adm.aws.int.test.visma.net',
    stag: 'adm.stag.visma.net',
    prod: 'adm.visma.net'
}